import React, { useCallback } from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ConditionalWrapper } from '~/modules/common/components';
import { ActionItemContent } from './ActionItemContent';

const useStyles = makeStyles(theme => ({
  linkContainer: {
    ...theme.typography.body1,
    textDecoration: 'none',
    minWidth: theme.spacing(22.5),
    maxWidth: theme.spacing(22.5),
    borderRadius: theme.spacing(1),
    cursor: 'pointer',
    '&:hover $linkText, &:focus $linkText': {
      color: theme.palette.primary.main
    }
  },
  linkText: {
    color: theme.palette.text.secondary,
    display: 'flex',
    justifyContent: 'center',
    transition: 'color 0.2s ease',
    position: 'relative',
    zIndex: 1
  }
}));

const useLinkItemStyles = makeStyles(theme => ({
  contentContainer: {
    padding: theme.spacing(2, 2, 0.25),
    minWidth: theme.spacing(22.5),
    maxWidth: theme.spacing(22.5)
  }
}));

export const ActionItemLink = ({ actionItem, isLoading }) => {
  const {
    title,
    formattedValue,
    className,
    showAsLink = false,
    onClick,
    link
  } = actionItem;
  const classes = useStyles();
  const linkItemClasses = useLinkItemStyles();

  const handleClick = useCallback(
    e => {
      if (onClick) {
        e.preventDefault();
        onClick();
      }
    },
    [onClick]
  );

  return (
    <ConditionalWrapper
      className={classes.linkContainer}
      condition={showAsLink}
      data-qe-id="actionItemLink"
      onClick={handleClick}
      to={link}
      WrapperComponent={Link}
    >
      <ActionItemContent
        classes={linkItemClasses}
        actionTitle={title}
        actionValue={formattedValue}
        actionClassName={className}
        isLoading={isLoading}
      >
        {showAsLink && (
          <Typography variant="caption" className={classes.linkText}>
            <FormattedMessage id="resourceManagementDashboard.actionItems.goToPage" />
          </Typography>
        )}
      </ActionItemContent>
    </ConditionalWrapper>
  );
};

ActionItemLink.propTypes = {
  actionItem: PropTypes.shape({
    key: PropTypes.string,
    title: PropTypes.string,
    formattedValue: PropTypes.string,
    className: PropTypes.string,
    link: PropTypes.string,
    state: PropTypes.object,
    showAsLink: PropTypes.bool,
    onClick: PropTypes.func
  }),
  isLoading: PropTypes.bool
};

export default ActionItemLink;
